import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { produce } from 'immer'

import { Theme } from '@mui/material/styles'

import {
  setTheme,
  setConfiguration,
  setMessage,
  setUser, getCurrentUser,
} from './settings.actions'

import { UserSettings } from '@professocialApi/professocial-core-frontend-api'

import { ApiError } from '../root.reducer'
import { Message } from '@professocial/professocialTypes/types/messageTypes'
import getAppTheme from '../../config/getAppTheme'
import { Customer } from '../../shared/types/commonTypes'

export interface SettingsState {
  fetching: boolean
  isAuthorized: boolean
  configuration?: never
  theme: Theme
  message?: Message
  user?: UserSettings
  error: ApiError
}

const INITIAL_SETTINGS_STATE: SettingsState = {
  fetching: false,
  theme: getAppTheme('de'),
  error: {},
  isAuthorized: false,
}

export const settingsStateReducer = reducerWithInitialState(INITIAL_SETTINGS_STATE)
  .case(setConfiguration, (state, configuration) => {
    return ({ ...state, configuration })
  })
  .case(setTheme, (state, theme) => {
    return ({ ...state, theme })
  })
  .case(setMessage, (state: SettingsState, message: Message) => {
    return ({ ...state, message })
  })
  .case(setUser, (state: SettingsState, user: UserSettings | undefined) => {
    return ({ ...state, user, isAuthorized: user !== undefined })
  })

/**
     * getUserAccount
     */
  .case(getCurrentUser.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      draft.isAuthorized = true
      delete draft.error.getCurrentUser
    })
  })

  .case(getCurrentUser.done, (state, { result }) => {
    return produce(state, draft => {
      draft.user = result
      draft.fetching = false
      draft.isAuthorized = true
      return draft
    })
  })

  .case(getCurrentUser.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.isAuthorized = false
      draft.error.getCurrentUser = (error as Response)
    })
  })
